import React, { Component } from 'react';
import { withStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';

import { Grid, MenuItem } from '@material-ui/core';
import {
  UploadComponent,
  ButtonGroup,
  InputField,
  Toggle,
  Divider,
  ButtonComponent,
  TableView,
} from '..';
import FantasySettings from './FantasySettings';

import { useStyles } from './styles.js';

class Fantasy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: false,
      ready: false,
      pool_size: null,
      draft_size: null,
      category: [],
    };
  }

  /** LIFE CYCLE METHODS */
  componentDidMount() {}

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  /**RENDER METHOD */
  render() {
    const { classes } = this.props;

    return (
      <Grid>
        <Divider />
        <FantasySettings
          current_tab={this.props.current_tab}
          onClick={this.props.onClick}
        />
        <Divider />

        <Grid container className={classes.gridContainer}>
          <Grid item md={2} xs={12}>
            {' '}
            <label>Ready To Upload</label>
          </Grid>
          <Grid item md={2} xs={12}>
            <Toggle
              name="ready"
              checked={this.state.ready}
              handleChange={e => {
                this.setState({ ready: !this.state.ready });
              }}
            />
          </Grid>
          {this.state.ready && (
            <Grid item md={4} xs={12}>
              <UploadComponent
                upload_type_name="Options"
                uploadObj={{
                  quarter_id: this.props.current_tab,
                  game_type_id: 5,
                  option_type: this.props.option_type,
                }}
                successCallback={this.props.successCallback}
                failureCallback={this.props.failureCallback}
              />
            </Grid>
          )}
        </Grid>
        <Divider />

        {this.props.chapter_settings &&
        this.props.chapter_settings[this.props.current_tab] &&
        this.props.chapter_settings[this.props.current_tab][
          'fantasy_questions'
        ] &&
        this.props.chapter_settings[this.props.current_tab]['fantasy_questions']
          .length > 0 ? (
          <TableView
            table_headers={{
              id: '#',
              option_id: 'Option id',
              option: 'Option',
              quarter_id: 'Chapter',
              group_id: 'Group',
              external_player_id: 'API Player ID',
              bkgd_hex_code: 'Hex Code',
            }}
            table_data={
              this.props.chapter_settings &&
              this.props.chapter_settings[this.props.current_tab] &&
              this.props.chapter_settings[this.props.current_tab][
                'fantasy_questions'
              ]
                ? this.props.chapter_settings[this.props.current_tab][
                    'fantasy_questions'
                  ]
                : []
            }
          />
        ) : (
          ''
        )}

        <ButtonGroup {...this.props} />
      </Grid>
    );
  }
}

Fantasy.propTypes = {
  className: PropTypes.string,
};

export default withStyles(useStyles)(Fantasy);